var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurfeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 235,
    viewBox: "0 0 375 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_632_3217)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.649,
    height: 235,
    rx: 10.8988,
    fill: "#FAF6FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.0605,
    y: 55.5596,
    width: 261.278,
    height: 191.454,
    rx: 6.00639,
    fill: "#FCEAFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_632_3217)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.7954,
    y: 71.3252,
    width: 289.057,
    height: 171.182,
    rx: 6.00639,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_632_3217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.711 135.12H349.097C351.606 135.12 353.626 137.14 353.626 139.65V212.326C353.626 214.836 351.606 216.856 349.097 216.856H175.711C173.202 216.856 171.182 214.836 171.182 212.326V139.65C171.182 137.14 173.202 135.12 175.711 135.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.941 207.514C183.941 207.514 186.15 179.904 192.5 162.509C198.85 145.115 210.999 174.382 218.73 186.806C226.461 199.231 241.923 167.755 257.937 182.389C273.95 197.022 288.86 175.762 301.837 177.971C314.814 180.18 341.319 207.514 341.319 207.514L183.941 207.514Z",
    fill: "#DFA8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.941 207.514H341.319C341.319 207.514 323.925 181.284 307.359 186.254C290.792 191.224 282.785 198.679 268.98 197.022C255.175 195.366 244.131 179.904 227.565 175.762C210.999 171.621 183.941 207.514 183.941 207.514Z",
    fill: "#C987EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.941 207.514C183.941 207.514 190.843 181.423 199.403 188.878C207.962 196.332 217.349 203.649 228.393 198.679C239.437 193.709 254.209 183.632 264.287 194.262C274.364 204.892 284.442 206.134 293.139 202.683C301.836 199.231 307.772 197.437 312.742 201.716C317.712 205.996 323.234 198.955 328.342 201.578C333.45 204.201 341.319 207.515 341.319 207.515L183.941 207.514Z",
    fill: "#AD49E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.416 150.914C215.416 152.743 213.933 154.227 212.103 154.227C210.273 154.227 208.79 152.743 208.79 150.914C208.79 149.084 210.273 147.601 212.103 147.601C213.933 147.601 215.416 149.084 215.416 150.914Z",
    fill: "#AD49E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.102 152.001C218.501 152.001 218.015 151.514 218.015 150.914C218.015 150.314 218.502 149.827 219.102 149.827H231.472C232.072 149.827 232.559 150.313 232.559 150.914C232.559 151.514 232.072 152.001 231.472 152.001H219.102Z",
    fill: "#C987EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.384 150.914C257.384 152.743 255.901 154.227 254.071 154.227C252.241 154.227 250.758 152.743 250.758 150.914C250.758 149.084 252.241 147.601 254.071 147.601C255.901 147.601 257.384 149.084 257.384 150.914Z",
    fill: "#FFB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.069 152.001C260.469 152.001 259.983 151.514 259.983 150.914C259.983 150.314 260.469 149.827 261.069 149.827H273.44C274.04 149.827 274.527 150.313 274.527 150.914C274.527 151.514 274.04 152.001 273.44 152.001H261.069Z",
    fill: "#C987EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.15 150.914C305.15 152.743 303.666 154.227 301.837 154.227C300.007 154.227 298.523 152.743 298.523 150.914C298.523 149.084 300.007 147.601 301.837 147.601C303.666 147.601 305.15 149.084 305.15 150.914Z",
    fill: "#AD49E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.835 152.001C308.234 152.001 307.748 151.514 307.748 150.914C307.748 150.314 308.235 149.827 308.835 149.827H321.205C321.805 149.827 322.292 150.313 322.292 150.914C322.292 151.514 321.805 152.001 321.205 152.001H308.835Z",
    fill: "#C987EB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.609 151.682H52.6047C50.5044 151.682 48.8018 149.98 48.8018 147.879V102.158C48.8018 100.058 50.5044 98.3555 52.6047 98.3555H148.609C150.709 98.3555 152.412 100.058 152.412 102.158V147.879C152.412 149.98 150.709 151.682 148.609 151.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.595 132.626C147.595 132.98 147.454 133.3 147.218 133.53C146.988 133.76 146.668 133.901 146.32 133.901H108.528C107.82 133.901 107.253 133.334 107.253 132.626C107.253 131.918 107.82 131.356 108.528 131.356H146.32C147.022 131.356 147.595 131.924 147.595 132.626Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 140.724C128.62 141.432 128.053 141.999 127.345 141.999H108.528C108.174 141.999 107.854 141.859 107.624 141.629C107.393 141.398 107.253 141.078 107.253 140.724C107.253 140.022 107.82 139.449 108.528 139.449H127.345C128.029 139.449 128.62 140 128.62 140.724Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.595 124.531C147.595 124.879 147.454 125.199 147.218 125.43C146.988 125.666 146.668 125.806 146.32 125.806H108.528C107.82 125.806 107.253 125.233 107.253 124.531C107.253 123.819 107.817 123.256 108.528 123.256H146.32C147.022 123.256 147.595 123.823 147.595 124.531Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.595 116.43C147.595 116.779 147.455 117.099 147.219 117.329C146.989 117.565 146.668 117.705 146.32 117.705H108.529C107.821 117.705 107.253 117.132 107.253 116.43C107.253 116.077 107.394 115.756 107.624 115.526C107.854 115.296 108.175 115.155 108.529 115.155H146.32C147.022 115.155 147.595 115.722 147.595 116.43Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.253 108.403C107.253 108.049 107.393 107.735 107.624 107.504C107.854 107.274 108.174 107.128 108.528 107.128H146.32C147.022 107.128 147.595 107.701 147.595 108.403C147.595 108.757 147.454 109.077 147.218 109.307C146.988 109.538 146.668 109.678 146.32 109.678H108.528C107.82 109.678 107.253 109.111 107.253 108.403Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8032 105.32C82.3081 103.35 77.0798 103.039 72.1101 104.868C61.8997 108.623 56.6672 119.945 60.423 130.156C64.1788 140.366 75.5006 145.598 85.711 141.843C90.2136 140.186 93.7435 137.056 95.9659 133.202L78.9105 123.355L86.8032 105.32Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.823 113.99C99.8953 108.749 95.9718 104.825 91.2307 102.749L83.3354 120.79L101.823 113.99Z",
    fill: "#71C687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.392 116.964L83.9043 123.764L100.96 133.611L100.964 133.61C103.78 128.724 104.491 122.671 102.392 116.964Z",
    fill: "#64D3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 55.1838,
    cy: 83.7136,
    r: 3.37859,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 65.695,
    cy: 83.7136,
    r: 3.37859,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 76.2057,
    cy: 83.7136,
    r: 3.37859,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M207.971 80.3041C207.971 82.3659 209.643 84.0373 211.704 84.0373H319.691C321.752 84.0373 323.423 82.3661 323.423 80.3044V80.304C323.423 78.2484 321.757 76.582 319.701 76.582H211.693C209.638 76.5822 207.971 78.2486 207.971 80.3041Z",
    fill: "#E4ECF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8892 213.876H58.562V208.549H59.7458V212.692H63.8892V213.876Z",
    fill: "#FBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7458 185.188H58.562V196.868H59.7458V185.188Z",
    fill: "#FBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7463 173.506H58.5625V168.179H63.8896V169.362H59.7463V173.506Z",
    fill: "#FBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.179 169.363H108.298V168.179H117.179V169.363ZM99.4149 169.363H90.534V168.179H99.4149V169.363ZM81.6509 169.363H72.77V168.179H81.6509V169.363Z",
    fill: "#FBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.39 173.506H130.206V169.362H126.062V168.179H131.39V173.506Z",
    fill: "#FBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.39 185.188H130.206V196.868H131.39V185.188Z",
    fill: "#FBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.389 213.876H126.062V212.692H130.205V208.549H131.389V213.876Z",
    fill: "#FBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.181 213.874H108.3V212.69H117.181V213.874ZM99.4169 213.874H90.536V212.69H99.4169V213.874ZM81.6529 213.874H72.772V212.69H81.6529V213.874Z",
    fill: "#FBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.062 208.549V173.507H63.8885L63.8885 208.549H126.062Z",
    fill: "#FBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M295.154 107.34C295.154 107.964 294.907 108.525 294.498 108.922C294.099 109.332 293.539 109.579 292.926 109.579H270.275C269.036 109.579 268.035 108.578 268.035 107.34C268.035 106.726 268.283 106.166 268.692 105.768C269.09 105.359 269.65 105.111 270.274 105.111H292.926C294.153 105.111 295.154 106.113 295.154 107.34Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M312.543 114.678C312.543 115.302 312.296 115.862 311.887 116.26C311.488 116.67 310.929 116.917 310.315 116.917H270.275C269.036 116.917 268.035 115.916 268.035 114.678C268.035 114.064 268.283 113.504 268.692 113.106C269.09 112.697 269.65 112.449 270.274 112.449H310.315C311.542 112.449 312.543 113.451 312.543 114.678Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M312.543 121.759C312.543 122.383 312.296 122.944 311.887 123.341C311.488 123.751 310.929 123.998 310.315 123.998H270.275C269.036 123.998 268.035 122.997 268.035 121.759C268.035 121.145 268.283 120.585 268.692 120.187C269.09 119.778 269.65 119.53 270.274 119.53H310.315C311.542 119.53 312.543 120.532 312.543 121.759Z",
    fill: "#D1DCF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.181 102.859H258.929V132.141H261.181V102.859Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.357 115.372C263.166 115.372 265.443 113.095 265.443 110.287C265.443 107.478 263.166 105.201 260.357 105.201C257.548 105.201 255.271 107.478 255.271 110.287C255.271 113.095 257.548 115.372 260.357 115.372Z",
    fill: "#F2D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_632_3217",
    x: -33.3356,
    y: -7.80899,
    width: 441.32,
    height: 323.444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.00319
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.0655
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_632_3217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_632_3217",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_632_3217",
    x: 146.105,
    y: 124.309,
    width: 232.597,
    height: 131.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.2652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5383
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_632_3217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_632_3217",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_632_3217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 374.649,
    height: 235,
    rx: 10.8988,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurfeature3);
export default __webpack_public_path__ + "static/media/ourfeature3.bb109530d1dda782ac5f412db4b9e150.svg";
export { ForwardRef as ReactComponent };